import React, { ButtonHTMLAttributes } from "react";
import "./TextButtonWithIcon.scss";
import { Typography } from "@husqvarna/ui-core";

export type TextButtonWithIconVariant = "primary" | "secondary" | "ghost";

export interface TextButtonWithIconProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children"> {
  icon: React.ReactNode;
  text: string;
  variant?: TextButtonWithIconVariant;
  iconPosition?: "start" | "end";
  iconSize?: "small" | "medium";
  textVariant?: "Body2" | "Body1";
  textClassName?: string;
}

const TextButtonWithIcon: React.FC<TextButtonWithIconProps> = ({
  icon,
  text,
  variant = "secondary",
  className,
  type = "button",
  iconPosition = "start",
  iconSize = "medium",
  textVariant = "Body2",
  textClassName,
  ...rest
}) => {
  const renderIcon = () => { return (
    <span className={`text-button-with-icon__icon`} aria-hidden>
      {icon}
    </span>
  )}
  return (
    <button
      type={type}
      className={`text-button-with-icon text-button-with-icon--${variant} text-button-with-icon__icon--${iconSize} ${className ?? ""}`.trim()}
      {...rest}
    >
      {iconPosition === "start" && (
        renderIcon()
      )}
      <Typography tag="span" variant={textVariant} text={text} className={textClassName} />
      {iconPosition === "end" && (
        renderIcon()
      )}
    </button>
  );
};

export default TextButtonWithIcon;
